import { Request } from './Request';
import { TeamStatusRequestResponse } from '@/data/models/TeamStatusRequestResponse';

export class GetTeamStatusRequest extends Request<TeamStatusRequestResponse> {
  method = 'GET';
  url = '/tc/teamstatus';
}
